<template>
	<div class="mt6 xs-12 wrap">
		<div class="xs-12 fs4 fw7 lh125 p1 mt2">{{ this.$t("identity_type") }}</div>
		<j-base-select :options="options" v-model="identityType" />
		<div v-if="identityType == 'other'" class="xs-12 fs4 fw7 lh125 p1 mt2">
			{{ $t("Label") }}
		</div>
		<j-base-input-text
			v-if="identityType == 'other'"
			size="medium"
			v-model="inputType"
			@input="onInputChange"
		/>
		<div v-if="identityType.length" class="xs-12 fs4 fw7 lh125 p1 mt2">
			{{ $t("value") }}
		</div>
		<j-base-input-text
			v-if="identityType.length"
			size="medium"
			v-model="inputValue"
			@input="onInputChange"
		/>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText"
import JBaseSelect from "@/components/JBaseSelect"

export default {
	name: "InputNewFact",
	components: {
		JBaseInputText,
		JBaseSelect
	},
	props: {
		value: {
			required: false
		}
	},
	data() {
		return {
			inputValue: "",
			inputType: "",
			identityType: "",
			options: [
				{ name: "HKID", value: "hkid" },
				{ name: "Passport", value: "passport" },
				{ name: "Other", value: "other" }
			]
		}
	},

	methods: {
		onInputChange() {
			this.$emit("input", {
				type: this.identityType == "other" ? this.inputType : this.identityType,
				value: this.inputValue
			})
		}
	}
}
</script>
